import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import GrupArgeEnergySummaryCards from "../../components/GrupArgeEnergySummaryCards";
import GrupArgeWeeklyActiveEnergyChart from "../../components/GrupArgeWeeklyActiveEnergyChart";
import GrupArgeWeeklyReactiveEnergyChart from "../../components/GrupArgeWeeklyReactiveEnergyChart";

import GrupArgeActiveEnergyPie from "../../components/GrupArgeActiveEnergyPie";
import GrupArgeReactiveEnergyPie from "../../components/GrupArgeReactiveEnergyPie";
import ConsumptionCalculatorDialog from "../../components/ConsumptionCalculatorDialog";

export default function GrupArgeEnergyDashboard({ deviceType = "gruparge" }) {
    const { t } = useTranslation();
    const { deviceId } = useParams();
    const API_BASE = process.env.REACT_APP_API_BASE_URL;

    const [summary, setSummary] = useState({});
    const [calcOpen, setCalcOpen] = useState(false);

    useEffect(() => {
        fetch(`${API_BASE}/gruparge/energy-summary?deviceId=${deviceId}`)
            .then(res => res.json())
            .then(data => setSummary(data))
            .catch(err => console.error("Energy summary fetch error:", err));
    }, [deviceId, API_BASE]);

    return (
        <div className="p-6 space-y-10">

            {/* Tüketim Hesaplama Butonu */}
            <div className="flex justify-end mt-2">
                <button
                    onClick={() => setCalcOpen(true)}
                    className="bg-orange-600 text-white px-4 py-2 rounded-md hover:bg-orange-700"
                >
                    {t('consumptionCalculator.dashboardButton')}
                </button>
            </div>

            {/* Özet Kartlar - Grup Arge'ye Özel */}
            {summary && <GrupArgeEnergySummaryCards data={summary} />}

            {/* Haftalık 7 Günlük Aktif & Reaktif */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <GrupArgeWeeklyActiveEnergyChart deviceId={deviceId} API_BASE={API_BASE} />
                <GrupArgeWeeklyReactiveEnergyChart deviceId={deviceId} API_BASE={API_BASE} />
            </div>

            {/* Pasta Grafikleri - Grup Arge'ye Özel (Birim kWh olduğu için 1000'e bölmeyi kaldırdık) */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <GrupArgeActiveEnergyPie
                    importVal={summary.PT_IMPORT ?? 0}
                    exportVal={summary.PT_EXPORT ?? 0}
                />

                <GrupArgeReactiveEnergyPie
                    importVal={summary.QT_IMPORT ?? 0}
                    exportVal={summary.QT_EXPORT ?? 0}
                />
            </div>

            <ConsumptionCalculatorDialog
                open={calcOpen}
                onClose={() => setCalcOpen(false)}
                deviceId={deviceId}
                API_BASE={API_BASE}
            />
        </div>
    );
}
